import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=42df8fcc&scoped=true&"
import script from "./CommentEditor.vue?vue&type=script&lang=js&"
export * from "./CommentEditor.vue?vue&type=script&lang=js&"
import style0 from "./CommentEditor.vue?vue&type=style&index=0&id=42df8fcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42df8fcc",
  null
  
)

export default component.exports